import { dataLayerPush } from './dataLayerPush';

export const SHIPPING_ADDRESS_ANALYTICS_EVENTS = {
    CLICK_EDIT: 'click_edit_shipping_address',
    SAVE: 'save_shipping_address',
    SAVE_EDIT: 'save_edit_shipping_address',
    ADD: 'add_shipping_address',
    REMOVE: 'remove_shipping_address',
    VIEW_CANNOT_REMOVE_MODAL: 'view_cannot_remove_address_modal',
} as const;

export type ShippingAddressAnalyticsEvent = keyof typeof SHIPPING_ADDRESS_ANALYTICS_EVENTS;

type ShippingAddressDataLayerPayload = {
    event: string;
    site_section: string;
};

const buildShippingAddressAnalyticsPayload = (
    type: ShippingAddressAnalyticsEvent,
    siteSection: string
): ShippingAddressDataLayerPayload => {
    const event = SHIPPING_ADDRESS_ANALYTICS_EVENTS[type];
    return {
        event,
        site_section: siteSection,
    };
};

export function trackShippingAddressEvents(type: ShippingAddressAnalyticsEvent, siteSection: string): void {
    dataLayerPush(buildShippingAddressAnalyticsPayload(type, siteSection));
}

export const trackViewUpdateAutoshipAddressModal = (siteSection: string) => {
    dataLayerPush({
        event: 'view_update_autoship_address_modal',
        site_section: siteSection,
    });
};

export const trackUpdateAutoshipAddress = (payload: { siteSection: string; linkText: string }) => {
    dataLayerPush({
        event: 'update_autoship_address',
        site_section: payload.siteSection,
        link_text: payload.linkText,
    });
};
